// src/pages/UnauthorizedPage.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Container,
    Box,
    Typography,
    Button,
    useTheme
} from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useAuth } from '../context/userContext';

export default function UnauthorizedPage() {
    const navigate = useNavigate();
    const theme = useTheme();
    const [{ user, loading }] = useAuth();
    return (
        <Container component="main" maxWidth="sm">
            <Box
                sx={{
                    minHeight: '80vh',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    py: 4,
                }}
            >
                <LockOutlinedIcon
                    sx={{
                        fontSize: 80,
                        color: theme.palette.error.main,
                        mb: 2,
                    }}
                />
                <Typography variant="h3" component="h1" gutterBottom>
                    Access Denied
                </Typography>
                <Typography
                    variant="h6"
                    color="textSecondary"
                    sx={{ mb: 4, maxWidth: 400 }}
                >
                    You don’t have permission to view this page. If you believe this
                    is an error, please contact your administrator.
                </Typography>
                <Box sx={{ display: 'flex', gap: 2 }}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => navigate(`/dashboard`)}
                    >
                        Go to Home
                    </Button>
                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={() => navigate(-1)}
                    >
                        Go Back
                    </Button>
                </Box>
            </Box>
        </Container>
    );
}
